// extracted by mini-css-extract-plugin
module.exports = {"tableDisplay":"styles_tableDisplay__1E181","withoutActions":"styles_withoutActions__3MCdW"};